export default {
    NotAllowed: 0,
    Mandatory: 1,
    Possible: 2,
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/carbon-purchase-options.js